import React from "react";

import { Button, Col, Row } from "react-bootstrap";

import styles from "./NotificationTile.module.scss";

interface NotificationTileProps {
  title: string;
  buttonText: string;
  buttonAction?: () => void;
}

export const NotificationTile = ({ title, buttonText, buttonAction }: NotificationTileProps) => {
  return (
    <Row className={`${styles.tile} align-items-center`}>
      <Col md={10}>{title}</Col>
      <Col md={2} className="d-flex justify-content-end">
        <Button
          onClick={buttonAction ? buttonAction : undefined}
          className={`${styles.notificationTileButton} ${!buttonAction ? styles.inactiveButton : ""}`}
        >
          {buttonText}
        </Button>
      </Col>
    </Row>
  );
};
